// extracted by mini-css-extract-plugin
export default {"header":"style_header__-K5jF","header_title":"style_header_title__dpApg","header_container":"style_header_container__8Dt0R","header_switcher":"style_header_switcher__-4u3I"};